import { DocumentType } from '../models/document-type';

/**
 * Map to document type.
 * @param {object} dto Dto.
 * @returns {DocumentType}
 */
function fromDto(dto) {
  return new DocumentType({
    id: dto.id,
    code: dto.code,
    name: dto.name,
    description: dto.description,
    backgroundImage: dto.background_image,
  });
}

export const documentTypeMapper = {
  fromDto,
};
